<template>
    <div id="AcceptPart">
        <a-row v-for="(item, index) in inputConfig" :key="index">
            <NormalInput v-if="item.inputStyle !== 'upload'" :isCanEdit="isCanEdit" :data="item" :index="index"></NormalInput>
            <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'" :data="item" @uploadFile="fileData"></NormalUpload>
        </a-row>
        <a-row v-if="isCanEdit" style="margin-top: 20px" type="flex" justify="center">
            <a-button v-if="buttonTitle" type="primary" @click="accept">{{buttonTitle}}</a-button>
        </a-row>
    </div>
</template>

<script>
import { buttonTitleConfig } from './CFPageDetailConfig'
import NormalInput from '../../components/NormalInput'
import NormalUpload from '../../components/NormalUpload'
import { checkInput } from '../../components/checkAllInput'

export default {
  name: 'AcceptPart',
  props: ['isCanEdit', 'inputConfig', 'activeKey', 'isShowAll', 'changeAcceptButtonshow', 'buttonCode'],
  components: {
    NormalInput,
    NormalUpload
  },
  data () {
    return {
      buttonTitle: '',
      showInputConfif: [],
    }
  },
  destroyed () {
  },
  created () {
    this.buttonTitle = buttonTitleConfig[parseInt(this.buttonCode)]
  },
  methods: {

    fileData (fileDate) {
      this.$emit('uploadFile', fileDate)
    },
    accept () {
      const buttonCode = parseInt(this.buttonCode)
      var isAllOK = true
      this.inputConfig.forEach(item => {
        if (item.inputStyle === 'date' || item.inputStyle === 'dateTime') {
          if (item.value && item.value !== '') {
            item.isOk = true
          } else {
            item.isOk = false
          }
        } else if (item.inputStyle === 'time') {
          if (item.value && item.value !== '') {
            item.isOk = true
          } else {
            item.isOk = false
          }
        } else {
          item = checkInput(item)
        }

        if (!item.isOk) {
          isAllOK = false
        }
      })

      // this.inputConfig.buttonCode = buttonCode
      if (isAllOK) {
        this.$emit('accept', {
            res: this.inputConfig,
            buttonCode: buttonCode
        })
      }
    }
  }
}
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #AcceptPart{
        background-color: #fff;
    }

</style>
